import React, { useEffect } from 'react';
import config from '../../helpers/config';
import { connect } from 'react-redux';
import { fetchTour } from '../actions';
import Helmet from '../components/Helmet';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import PageCover from '../components/PageCover';
import Logo from '../components/Logo';
import { Typography } from '@material-ui/core';
import { Facility, Room, BeautyPerfect, MommyBabyBanner } from '../components/tour';
import useDeepCompareEffect from 'use-deep-compare-effect'

const useStyles = makeStyles(theme => ({
    tourBackground: {
        backgroundColor: '#fcfeff'
    },
    logoDiv: {
        padding: '100px 0px'
    }
}));


const TourPage = (props) => {

    const theme = useTheme(), 
        { tour } = props,
        classes = useStyles(tour);

    useDeepCompareEffect(() => {
        if (!tour.isLoaded) props.fetchTour();
    }, [tour])

    if (!tour.isLoaded) {
        return <div>Loading...</div>;
    }

    const PageCoverProps = {
            ...tour,
            style: {
                height: 'calc(100vh - 75px)',
                title: {
                    position: 'absolute',
                    top: 'auto',
                    right: '0',
                    bottom: '10%',
                    left: 'auto',
                    width: '33%',
                    letterSpacing: '10px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    color: 'white',
                    fontWeight: '500',
                    padding: '20px 0px 20px 5vw',
                    borderTopLeftRadius: '40px',
                    borderBottomLeftRadius: '40px',
                    border: '1px solid #dadada',
                    textShadow: '1px 1px 4px black',
                    '& h1': {
                        float: 'left',
                        fontWeight: '500'
                    },
                    [theme.breakpoints.down('xs')] : {
                        width: '75%',
                    }
                }
            }
        };
    return (
        <div className={classes.container}>
            <Helmet {...tour} />
            <div className={classes.tourBackground}>
                <PageCover {...PageCoverProps} > 
                    <Typography variant="h1">{tour.name}</Typography>
                </PageCover>

                <div className={classes.logoDiv}>
                    <Logo />
                </div>

                <BeautyPerfect {...tour} />

                <Room {...tour}/>
             
                <MommyBabyBanner {...tour} />

                <Facility {...tour} />

            </div>
        </div>
    )
}

function mapStateToProps({tour}) {
    return { tour };
}

export default {
    loadData: ({dispatch}) => dispatch(fetchTour()),
    component:  connect(mapStateToProps, { fetchTour }) (TourPage)
}


// WEBPACK FOOTER //
// ./src/client/pages/TourPage.js